import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1);

const _hoisted_3 = {
  key: 0,
  class: "base_main_header"
};
const _hoisted_4 = {
  key: 1,
  class: "base_main_margin_top"
};
import DataCollectTable from "@com/table/DataCollectTable.vue";
import { operationsHander } from "@com/table/tableOperations";
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import $ from "@util/base";
import api from "@api/order";
export default {
  __name: 'PlusOrder',
  props: {
    type: {
      type: String
    },
    routeName: {
      type: String
    }
  },

  setup(__props) {
    const props = __props;
    const route = useRoute();
    route.watchRouter(props.routeName, () => {
      getData();
    });
    const base = ref(route.query().base || "");
    const main = ref(route.query().main || "");
    const orderCode = ref(route.query().orderCode || "");
    const loginName = ref(route.query().loginName || "");
    const date = ref(route.query().date || []);
    const total = ref(0);
    const data = ref([]);
    const config = {
      showIndex: true,
      column: [// {
      //   label: "主订单编号",
      //   prop: "mainOrderCode",
      //   width: 110,
      // },
      {
        label: "订单编号",
        prop: "orderCode"
      }, {
        label: "订单状态",
        prop: "orderStatusStr"
      }, {
        label: "用户名称",
        prop: "nickname"
      }, {
        label: "用户账号",
        prop: "loginName"
      }, {
        label: "下单时间",
        prop: "createTime"
      }, {
        label: "有效期",
        prop: "expiringTime"
      }]
    };
    const opHander = operationsHander();

    function getExport() {
      let routeQuery = route.query();
      let params = {
        type: "plus",
        memberLoginName: routeQuery.loginName,
        orderCode: routeQuery.orderCode,
        date: routeQuery.date
      };
      api.export(params, val => {
        $.download(val.url, "会员订单导出");
      });
    }

    function searchOrderCode(val) {
      route.replaceQuery("orderCode", val);
    }

    function searchName(val) {
      route.replaceQuery("loginName", val);
    }

    function searchDate(val) {
      route.replaceQuery("date", val);
    }

    getData();

    function getData() {
      getList();
    }

    function getList() {
      let routeQuery = route.query();
      let params = {
        type: "plus",
        mainOrderCode: routeQuery.main,
        orderCode: routeQuery.orderCode,
        memberLoginName: routeQuery.loginName,
        date: routeQuery.date,
        page: routeQuery.p,
        size: routeQuery.s
      };
      api.orderList(params, val => {
        total.value = val.total;
        data.value = val.list;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        inline: true,
        class: "base_search_form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => date.value = $event),
            type: "daterange",
            "range-separator": "~",
            "start-placeholder": "开始时间",
            "end-placeholder": "结束时间",
            "value-format": "YYYY-MM-DD",
            onChange: searchDate
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: orderCode.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => orderCode.value = $event),
            "onKeyup[native]": searchOrderCode,
            onChange: searchOrderCode,
            placeholder: "订单编号",
            "suffix-icon": _unref(Search),
            clearable: ""
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: loginName.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => loginName.value = $event),
            "onKeyup[native]": searchName,
            onChange: searchName,
            placeholder: "用户账号",
            clearable: "",
            "suffix-icon": _unref(Search)
          }, null, 8, ["modelValue", "suffix-icon"])]),
          _: 1
        })]),
        _: 1
      })]), props.type == 'order' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        text: "",
        onClick: getExport
      }, {
        default: _withCtx(() => [_createTextVNode("导出")]),
        _: 1
      })), [[_directive_auth, _ctx.getCurCode('EXPORT')]])])) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _createVNode(DataCollectTable, {
        data: data.value,
        total: total.value,
        config: config,
        onOperationsHander: _unref(opHander).receive
      }, null, 8, ["data", "total", "onOperationsHander"])]);
    };
  }

};